import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { Global } from "../../../data/Global";
import { _SvCicloEscolarEditar, _SvCicloEscolarEliminar, _SvCicloEscolarNuevo } from "../../../data/modulo/CicloEscolar";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { DataModuloMain } from "../../../data/ModuloMain";
import { DataUtil } from "../../../data/util/Util";
import { DateV2 } from "../../../util/DateV2";
import { IConfigCardCollapseExcelExport } from "../../controlD3/CardV1/CardCollapseAdvancedTable";
import { TCARDV2COLL_OnEditOriginEvent } from "../../controlD3/CardV2/CardV2Collapse";
import { CardV2CollapseAdvancedTable } from "../../controlD3/CardV2/CardV2CollapseAdvancedTable";
import { Table } from "../../controlD3/Tabla";
import { UIUtilLang } from "../../util/Language";
import { UIUtilPermission } from "../../util/Permission";
import { UIUtilTime } from "../../util/Time";
import { GetCicloEscolarPeriodoForm, GetEditionPeriodsObject } from "../../utilView/EscuelaPanel/CicloEscolar";

import CAccionPermiso = Entidad.CAccionPermiso
import ICicloEscolar = Entidad.ICicloEscolar;
import ICicloEscolarPeriodo = Entidad.ICicloEscolarPeriodo;
import IEscuela = Entidad.IEscuela;

export class UIPanelCardEscuelasCicloEscolar extends CardV2CollapseAdvancedTable<ICicloEscolar, [IEscuela]> {
    constructor() {
        super("", Entidad.CModulo.PanelCicloEscolar);
    }

    protected Table_GetMenuDataSelected(): Array<Table.ITableMenuDataSelectedOptionConfig<ICicloEscolar>> {
        let opciones: Array<Table.ITableMenuDataSelectedOptionConfig<ICicloEscolar>> = [];

        if (Global._GLOBAL_CONF.DEBUG_MODE && DataUtil._Usuario.Perfil == Entidad.CTipoPerfil.Admin && this.HasMateriasModule()) {
            opciones.push({
                Label: "action_editar",
                Callback: (datos) => this.OpenModal_EditarCicloEscolar(datos[0])
            })
        }

        //if (this.HasActionPermission(data.Entidades.CAccionPermiso.Eliminar)) {
        // MISSING_PERMISSION Eliminar
        if (DataUtil._Usuario.Perfil == Entidad.CTipoPerfil.Admin) {
            opciones.push({
                Label: "action_eliminar",
                Callback: (datos) => this.OpenModal_EliminarDatos(datos)
            })
        }
        // }

        return opciones;
    }

    private OpenModal_FormularioAgregar() {
        const escuela = this.cardData[0];
        let hasMateriasModule = Global._GLOBAL_CONF.DEBUG_MODE && this.HasMateriasModule();
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: "action_agregar",
            Width: 500,
            Action: CAccionPermiso.Agregar,
            IdsEscuelas: [escuela.IdKinder],
            GetForm: () => GetCicloEscolarPeriodoForm(CAccionPermiso.Agregar, null, escuela.IdKinder, hasMateriasModule),
            OnAccept: (form) => {
                return this.Sv_Alta(escuela, form._Data)
            },
            TypeRequest: Entidad.CTipoRequest.CicloEscolar,
            OnEndReloadService: async () => this.UI_UpdateTable(),
        })
    }

    private OpenModal_EditarCicloEscolar(ciclo: ICicloEscolar) {
        const escuela = this.cardData[0];
        let hasMateriasModule = Global._GLOBAL_CONF.DEBUG_MODE && this.HasMateriasModule();
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: "action_editar",
            Width: 500,
            Action: CAccionPermiso.Editar,
            IdsEscuelas: [escuela.IdKinder],
            GetForm: () => GetCicloEscolarPeriodoForm(CAccionPermiso.Editar, ciclo, escuela.IdKinder, hasMateriasModule),
            OnAccept: (form) => {
                let { Periodos: processedPeriods } = form._Data;
                const { Periodos: periodsOrigin } = form._DataOrigin;

                console.log({ processedPeriods, periodsOrigin })

                const { periodsAdd, periodsEdit, periodsDelete } = GetEditionPeriodsObject(periodsOrigin, processedPeriods);
                return this.Sv_Editar(escuela, form._Data, periodsAdd, periodsEdit, periodsDelete.map(d => d.Id));
            },
            TypeRequest: Entidad.CTipoRequest.CicloEscolar,
            OnEndReloadService: async () => this.UI_UpdateTable()
        })
    }

    private OpenModal_EliminarDatos(datos: ICicloEscolar[]) {
        this.CARDCOLLAD_OpenModal_ProccessArrayData<ICicloEscolar>({
            // Tittle: "Eliminar ciclos escolares",
            DataToProccess: datos,
            TypeRequest: Entidad.CTipoRequest.CicloEscolar,
            OnGetIdEscuela: (dato) => dato.IdEscuela,
            OnError_GetItemDataTag: (dato) => (
                `<b>${dato.Nombre}</b>\n`
                + `${this.CARDCOLL_GetUIStringModule("tag_periodo")}: ${UIUtilTime._DateFormatStandarFixTimeZone(dato.FechaInicio, this.cardData[0].ZonaHoraria)} - ${UIUtilTime._DateFormatStandarFixTimeZone(dato.FechaFin, this.cardData[0].ZonaHoraria)}`
            ),
            OnStepAProccess: async (dato) => {
                let res = await this.Sv_Eliminar(dato);
                if (res.Resultado == -1 || res.Resultado == -2) {
                    res.Mensaje = UIUtilLang._GetHTTPMessage(res, "Eliminar");
                }
                return res;
            },
            OnEndAndCloseProccess: async (correctos, incorrectos) => {
                if (correctos.length) {
                    this.UI_UpdateTable();
                }
            }
        })
    }

    private UI_UpdateTable() {
        this.ctrlTabla._UpdateData(this.GetCiclosEscolares());
    }

    protected CARDCOLL_MostrarBody() {
        this.cardSelection.style("height", "100%");
        return this;
    }

    protected CARDCOLL_OcultarBody(): void {
        this.cardSelection.style("height", null);
    }
    protected CARDCOLL_OnEditarCard(): void {
        // throw new Error("Method not implemented.");
    }
    protected CARDCOLL_OnCancelaEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
    }
    protected CARDCOLL_GuardarCardV2(): Promise<DataDRequest.IRequestResponseA<any>> {
        throw new Error("Method not implemented.");
    }

    protected CARDCOLL_OnInitBuild(contentContainer: TSelectionHTML<"div", any, any>): void {
        this.cardFooterSelection.remove();
        this.btnEditarCard._d3Selection.remove();
        this.cardHeaderSelection.remove();
    }

    protected CARDCOLL_GetVariantToValidateUpdate(cardData_0: IEscuela): string {
        return null;
    }

    protected CARDCOLL_OnUpdateData(cardData_0: IEscuela): void {
        this.UI_UpdateTable();
    }

    protected CARDCOLL_SyncOrGetIdToDownloadData(): DataModuloMain.TipoRequestMonitorId | (() => Promise<any>) | DataModuloMain.TipoRequestMonitorId[] {
        return Entidad.CTipoRequest.CicloEscolar
    }

    protected CARDCOLL_GetIdSchool(cardData_0_0: IEscuela): number {
        return cardData_0_0.IdKinder;
    }

    protected CARDCOLLADTAB_Table_GetConfig(): Omit<Table.IConfig<ICicloEscolar>, keyof Pick<Table.IConfig<ICicloEscolar>, "Parent">> {
        return {
            IdTabla: "EscuelasPanelCicloEscolar",
            Title: "",
            IdData: "Id",
            OrderDefault: { Type: Table.CStatusOrder.Asc, Field: "FechaInicio" },
            MinWidth: 600,
            RenderColumnHeadings: [
                { Field: "Nombre", Label: "Nombre", Width: "40%", MinWidth: "75px", OrderTypeParse: String },
                { Field: "FechaInicio", Label: "Inicio", Width: "25%", MinWidth: "75px", OrderTypeParse: Date },
                { Field: "FechaFin", Label: "Fin", Width: "25%", MinWidth: "75px", OrderTypeParse: Date }
            ],
            OptionsTopDefaultV2: {
                MaxOptionsInRow: 3,
                Options: [] // this.TableGetMenu()
            },
            OptionsOfActiveSelectedDataV3: () => {
                if (this.cardData?.length) {
                    return this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "top-selected", this.Table_GetMenuDataSelected());
                }
                return null;
            },
            EvaluatorAndSubLevelsBuild: {
                GetOptionsInRowV2: () => this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "row", this.Table_GetMenuDataSelected()),
                OnStepCellTable: (container, datum, field, step) => {
                    switch (field) {
                        case "FechaInicio":
                            container.text(UIUtilTime._DateFormatStandarFixTimeZone(datum.FechaInicio, this.cardData[0].ZonaHoraria));
                            return false;
                        case "FechaFin":
                            container.text(UIUtilTime._DateFormatStandarFixTimeZone(datum.FechaFin, this.cardData[0].ZonaHoraria));
                            return false;
                    }
                    return true;
                }
            }
        }
    }

    protected CARDCOLLADTAB_Table_GetMenuTop(): Table.ITableMenuTopDefaultOptionConfig[] {
        let opciones: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        if (this.HasActionPermission(Entidad.CAccionPermiso.Agregar)) {
            opciones.push({
                Label: "action_agregar",
                Callback: () => this.OpenModal_FormularioAgregar()
            })
        }

        return opciones;
    }

    protected CARDCOLLADTAB_GetExportarConfig(dataTable: ICicloEscolar[]): IConfigCardCollapseExcelExport<ICicloEscolar> {
        const escuela = this.cardData[0];
        return {
            FileName: escuela.Nombre + " - " + this.CARDCOLL_GetUIStringModule("tag_ciclosescolares"),
            IdsEscuelas: [escuela.IdKinder],
            TypeRequest: Entidad.CTipoRequest.Escuela,
            ColumnsConfig: this.ctrlTabla._InfoColumns
                .map(d => ({
                    Field: d.Field as keyof ICicloEscolar,
                    HeaderTag: d.Label,
                    WidthCell: 25
                })),
            OnGetDataBySheets: async () => {
                return [{
                    IdSheet: escuela.IdKinder, // IdEscuela
                    SheetName: escuela.Nombre,
                    Data: dataTable,
                }]
            },
            OnGetEscuelasTagInSheet: (datos) => _DICC_ESCUELA.get(escuela.IdKinder).Nombre,
            OnStepFieldInDataRow: (field, dato) => {
                if ((field == "FechaInicio" || field == "FechaFin") && dato[field]) {
                    return UIUtilTime._DateFormatStandarFixTimeZone(dato[field], this.cardData[0].ZonaHoraria);
                }
                return dato[field] as string;
            }
        }
    }

    // **************************************************************************
    // PERMISOS
    // **************************************************************************

    private HasMateriasModule(): boolean {
        const escuela = this.cardData[0];
        return UIUtilPermission._HasCalifModulesPermissionFromSchools(escuela.IdKinder);
    }

    // **************************************************************************
    //  SERVICIOS Y DATA
    // **************************************************************************

    private GetCiclosEscolares() {
        if (this.cardData[0]) {
            return DataModuloMain._GetReqDataArrayByName("CicloEscolar")
                .filter(d => (d.IdEscuela == this.cardData[0].IdKinder));
        }
        return []
    }

    private Sv_Alta(escuela: IEscuela, dataForm: ICicloEscolar) {
        let fechaInicio = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(dataForm.FechaInicio))
            ._SetTimeZone(escuela.ZonaHoraria, true)
            ._ToISOString();
        let fechaFin = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(dataForm.FechaFin))
            ._SetTimeZone(escuela.ZonaHoraria, true)
            ._ToISOString();
        return _SvCicloEscolarNuevo({
            IdEscuela: escuela.IdKinder,
            Nombre: dataForm.Nombre,
            FechaInicio: fechaInicio,
            FechaFin: fechaFin,
            Periodos: dataForm.Periodos
        })
    }

    private Sv_Editar(escuela: IEscuela, dataForm: ICicloEscolar, periodsToAdd: ICicloEscolarPeriodo[], periodsToEdit: ICicloEscolarPeriodo[], periodsToDeleteIds: number[]) {
        let fechaInicio = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(dataForm.FechaInicio))
            ._SetTimeZone(escuela.ZonaHoraria, true)
            ._ToISOString();
        let fechaFin = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(dataForm.FechaFin))
            ._SetTimeZone(escuela.ZonaHoraria, true)
            ._ToISOString();

        return _SvCicloEscolarEditar(
            {
                Id: dataForm.Id,
                Nombre: dataForm.Nombre,
                FechaInicio: fechaInicio,
                FechaFin: fechaFin,
            },
            periodsToAdd,
            periodsToEdit,
            periodsToDeleteIds,
        )
    }

    private Sv_Eliminar(datoCE: ICicloEscolar) {
        return _SvCicloEscolarEliminar(datoCE.Id, datoCE.IdEscuela);
    }
}
